import {
  AppointmentConfigurationControllerApi,
  AppointmentConfigurationDto,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  appointmentConfigurationDto: AppointmentConfigurationDto;
  xTENANTID?: string;
};

export const useUpdateAppointmentConfiguration = () =>
  useMutationWithLoading(async ({appointmentConfigurationDto,xTENANTID}: Params) =>
    new AppointmentConfigurationControllerApi(
      getConfigObject()
    ).updateConfiguration2(
      appointmentConfigurationDto,
      xTENANTID
    )
  );
